module.exports = "0.37.0";



//////////////////
// WEBPACK FOOTER
// ./node_modules/autocomplete.js/version.js
// module id = 0D3p
// module chunks = 0